import { LoginUser } from "../Adapters/LoginUser";

const SubmitNormalLoginData = (UserPass, navigate) => {
  LoginUser(UserPass, navigate);
};

export default SubmitNormalLoginData;
